import React from 'react';
import Alert from './Alert';

export default function ErrorAlert({ error, className }) {
  if (!error) return null;
  const { code, message } = typeof error === 'string'
    ? { code: null, message: error }
    : error;

  return (
    <Alert type="error" className={className}>
      {code && <span className="mr-1.5 rounded bg-red-100 px-1.5 py-0.5 font-mono text-xs">{code}</span>}
      {message}
    </Alert>
  );
}
